import * as Yup from "yup"
import {ParseError, parsePhoneNumberFromString} from "libphonenumber-js"
import {US_COUNTRY_CODE} from "../resources/address"

export function escapeRegExp(string: string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
}

export function addCustomValidationMethods() {
	Yup.addMethod(Yup.string, "phoneNumber", function (message) {
		return this.test("phoneNumberTest", message, function (value) {
			let isError = false
			let phoneNumber

			try {
				isError = false
				const phone = value ?? ""

				phoneNumber = parsePhoneNumberFromString(phone, {
					defaultCountry: US_COUNTRY_CODE,
				})
			} catch (error) {
				if (error instanceof ParseError) {
					isError = true
				}

				console.log(error)
			}

			if (typeof phoneNumber === "undefined") {
				return false
			}

			return !isError && phoneNumber.isValid()
		})
	})
}

export const countryRegex =
	"^(A(D|E|F|G|I|L|M|N|O|R|S|T|Q|U|W|X|Z)|B(A|B|D|E|F|G|H|I|J|L|M|N|O|Q|R|S|T|V|W|Y|Z)|C(A|C|D|F|G|H|I|K|L|M|N|O|R|U|V|W|X|Y|Z)|D(E|J|K|M|O|Z)|E(C|E|G|H|R|S|T)|F(I|J|K|M|O|R)|G(A|B|D|E|F|G|H|I|L|M|N|P|Q|R|S|T|U|W|Y)|H(K|M|N|R|T|U)|I(D|E|Q|L|M|N|O|R|S|T)|J(E|M|O|P)|K(E|G|H|I|M|N|P|R|W|Y|Z)|L(A|B|C|I|K|R|S|T|U|V|Y)|M(A|C|D|E|F|G|H|K|L|M|N|O|Q|P|R|S|T|U|V|W|X|Y|Z)|N(A|C|E|F|G|I|L|O|P|R|U|Z)|OM|P(A|E|F|G|H|K|L|M|N|R|S|T|W|Y)|QA|R(E|O|S|U|W)|S(A|B|C|D|E|G|H|I|J|K|L|M|N|O|R|T|V|X|Y|Z)|T(C|D|F|G|H|J|K|L|M|N|O|R|T|V|W|Z)|U(A|G|M|S|Y|Z)|V(A|C|E|G|I|N|U)|W(F|S)|XK|Y(E|T)|Z(A|M|W))$"
export const stateRegex =
	"^((A[LKSZR])|(C[AOT])|(D[EC])|(F[ML])|(G[AU])|(HI)|(I[DLNA])|(K[SY])|(LA)|(M[EHDAINSOT])|(N[EVHJMYCD])|(MP)|(O[HKR])|(P[WAR])|(RI)|(S[CD])|(T[NX])|(UT)|(V[TIA])|(W[AVIY]))$"
export const ssnRegex = /^[0-9]{3}\-?[0-9]{2}\-?[0-9]{4}$/
export const einRegex = /^[0-9]{2}\-?[0-9]{7}$/

// Phone regex patterns for validation
export const usCountryCodeRegex = /^1$/ // U.S. country code
export const usPhoneNumberRegex = /^\d{10}$/ // 10-digit U.S. phone number

export const intlCountryCodeRegex =
	/^(93|358|355|213|684|376|244|1264|672|1268|54|374|297|61|43|994|1242|973|880|1246|375|32|501|229|1441|975|591|599|387|267|55|55|246|673|359|226|257|855|237|238|1345|236|235|56|86|61|61|57|269|242|242|682|506|225|385|53|599|357|420|45|253|1767|1809|1829|1849|593|20|503|240|291|372|251|500|298|679|358|33|594|689|241|220|995|49|233|350|30|299|1473|590|1671|502|44|224|245|592|509|379|504|852|36|354|91|62|98|964|353|44|972|39|1876|81|44|962|77|254|686|82|850|383|965|996|856|371|961|266|231|218|423|370|352|853|389|261|265|60|960|223|356|692|596|222|230|262|52|691|373|377|976|382|1664|212|258|95|264|674|977|31|687|64|505|227|234|683|672|1670|47|968|92|680|970|507|675|595|51|63|872|48|351|1939|974|262|40|7|250|590|290|1869|1758|599|508|1784|685|378|239|966|221|381|248|232|65|599|421|386|677|252|27|500|211|34|94|249|597|47|268|46|41|963|886|992|255|66|670|228|690|676|1868|216|90|993|1649|688|256|380|971|44|246|598|998|678|58|84|1284|1340|681|212|967|260|263)$/ // International country codes
export const intlPhoneNumberRegex = /^\d+$/ // International phone number (digits only)

export const flexibleUrlRegex =
	/^(http(s)?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,12}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/i

export const name = {
	required: "Please enter your business name",
}

export const fullName = {
	first: {
		required: "Please enter your first name",
	},
	last: {
		required: "Please enter your last name",
	},
}

export const ssn = {
	required: "Please enter your full, 9-digit Social Security Number",
	invalid: "The Social Security Number you have provided is invalid (format is xxx-xx-xxxx)",
}

export const nationality = {
	required: "Please select the nationality",
	invalid: "The nationality you have provided is invalid",
}

export const passport = {
	required: "Please enter your full passport",
}

export const matriculaConsular = {
	required: "Please enter your matricula consular",
}

export const address = {
	street: {
		required: "Please enter the street name",
	},
	city: {
		required: "Please enter your city of residence",
	},
	state: {
		required: "Please select the state of residence",
	},
	postalCode: {
		required: "Please enter your zip code (must be 5 or 9 digits long)",
		usInvalid: "The zip code you have provided is invalid (US zip codes must be 5 or 9 digits long)",
		caInvalid:
			"The zip code you have provided is invalid (CA zip codes are in a A1A 1A1 format, where A is a letter and 1 is a digit)",
	},
	country: {
		required: "Please select the country of residence",
	},
}

export const dateOfBirth = {
	required: "Please enter the date of birth",
	max: "Must be earlier than today",
}

export const ein = {
	invalid: "The EIN you have entered is invalid (must be 9 digits long)",
}

export const phone = {
	countryCode: {
		required: "Please enter the country code",
		invalid: "Invalid country code",
	},
	number: {
		required: "Please enter the phone number",
		usInvalid: "The phone number must be a 10-digit number for U.S. phone numbers",
		intlInvalid: "The phone number you have provided is invalid for international phone numbers",
	},
}

export const website = {
	invalid: "The website URL you have provided is invalid",
	required: "Please enter your website",
}

export const email = {
	invalid: "The email you have provided is invalid",
	required: "Please enter your email address",
}

export const getErrorMessage = (error: any): string => {
	let fieldName: string | null = null

	// Check if error has the expected structure
	if (error?.source?.pointer) {
		try {
			const pointer = error.source.pointer
			const attributesMatch = pointer.split("data/attributes/")

			if (attributesMatch.length >= 2) {
				const fieldPath = attributesMatch[1]
				const extractedFieldName = fieldPath.split("/")[0]

				if (extractedFieldName) {
					fieldName = extractedFieldName
				}
			}
		} catch {
			// Continue to fallback
		}
	}

	// Return field name if extracted successfully, otherwise fall back to error detail/title
	return fieldName
		? `Invalid ${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}`
		: error?.detail || error?.title || "An error occurred"
}
